/* eslint react/forbid-prop-types: 0 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { compose, withProps } from "recompose";
import {
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow
} from "react-google-maps";

// // Need locations embed=** for address data
const AddressDisplay = ({ address }) => {
  const { number, street, suburb, postcode, state } = address;
  return (
    <span>
      {number} {street}, {suburb} {postcode} {state}
    </span>
  );
};
AddressDisplay.propTypes = {
  address: PropTypes.object.isRequired
};

const JobDetail = ({ job }) => {
  const jobItems = job.jobItems.map(jobItem => {
    const { quantity, description } = jobItem.item;
    return <li key={jobItem.id}>{`${quantity}x ${description}`}</li>;
  });

  // <AddressDisplay address={job.stop.location.address}/>
  return (
    <table className="table table-bordered table-striped no-margin">
      <tbody>
        <tr>
          <td>Job Name</td>
          <td>{job.customerName}</td>
        </tr>
        <tr>
          <td>Address</td>
          <td>
            <AddressDisplay address={job.stop.location.address} />
          </td>
        </tr>
        <tr>
          <td>Job Type</td>
          <td>{job.type}</td>
        </tr>
        <tr>
          <td>Items</td>
          <td>
            <ul className="list-unstyled">{jobItems}</ul>
          </td>
        </tr>
      </tbody>
    </table>
  );
};
JobDetail.propTypes = {
  job: PropTypes.object.isRequired
};

class JobMarker extends Component {
  state = {
    isOpen: false
  };

  onToggleOpen = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  render() {
    const { job } = this.props;
    const { Lat, Lng } = job.stop.location.GPS;

    return (
      <Marker
        title={job.customerName}
        position={{ lat: Lat, lng: Lng }}
        onClick={this.onToggleOpen}
      >
        {this.state.isOpen && (
          <InfoWindow onCloseClick={this.onToggleOpen}>
            <JobDetail job={job} />
          </InfoWindow>
        )}
      </Marker>
    );
  }
}
JobMarker.propTypes = {
  job: PropTypes.object.isRequired
};

const GOOGLE_API_KEY = "AIzaSyDAQqCVDjer9kXq_opMYPQOtaTdcImZLU0";
const googleMapURL = `https://maps.googleapis.com/maps/api/js?key=${
  GOOGLE_API_KEY
}&v=3.exp&libraries=geometry,drawing,places`;
// Take a collection of jobs with proper location data (Lat & Lng) and displays them on a map with markers
const enhance = compose(
  withProps({
    googleMapURL,
    loadingElement: <div className="map-full-height" />,
    containerElement: <div className="mapview-container" />,
    mapElement: <div className="map-full-height" />
  }),
  withGoogleMap
);

const JobsViewMapComponent = props => {
  const { jobs, locations } = props;
  const jobsWithGps = [];

  jobs.forEach(job => {
    if (job.stop.location.GPS) {
      jobsWithGps.push(job);
    } else {
      const location = locations.find(
        l => l.id === parseInt(job.stop.location.id, 10)
      );
      if (location && location.GPS) {
        const jobWithLocation = Object.assign({}, job);
        const currentLocationData = job.stop.location;
        jobWithLocation.stop.location = { ...currentLocationData, ...location };
        jobsWithGps.push(jobWithLocation);
      }
    }
  });

  if (jobsWithGps.length) {
    const jobMarkers = jobsWithGps
      .filter(j => j.stop.location.GPS)
      .map(job => <JobMarker key={job.externalId || job.id} job={job} />);

    const firstJob = jobsWithGps[0];
    const firstJobGps = firstJob.stop.location.GPS;

    return (
      <GoogleMap
        defaultZoom={11}
        defaultCenter={{ lat: firstJobGps.Lat, lng: firstJobGps.Lng }}
      >
        {jobMarkers}
      </GoogleMap>
    );
  }

  return (
    <GoogleMap
      defaultZoom={11}
      defaultCenter={{ lat: -37.814, lng: 144.96332 }}
    />
  );
};
JobsViewMapComponent.propTypes = {
  jobs: PropTypes.array.isRequired,
  locations: PropTypes.array.isRequired
};

export default enhance(JobsViewMapComponent);



// WEBPACK FOOTER //
// ./src/MapView.js